import NoAssignmentsCard from 'src/components/assignments/no-assignments-card';
import { NoMiddleSchoolAssignmentsCard } from 'src/components/middle-school-view';
import { AssignmentsViewOptions } from 'src/interfaces/assignment.types';

export type NoAssignmentDataViewProps = {
  isMiddleSchoolView: boolean;
  k5Section?: AssignmentsViewOptions.PAST_WORK | AssignmentsViewOptions.TODO;
};

export const NoAssignmentDataView = ({
  isMiddleSchoolView,
  k5Section,
}: NoAssignmentDataViewProps) => {
  if (!isMiddleSchoolView) {
    return <NoAssignmentsCard k5Section={k5Section} />;
  }

  return <NoMiddleSchoolAssignmentsCard />;
};
